import { post, postJson, get, deleteApiJson, imagePost } from './axios'
import { postBlob } from './axios2'

const RESOURCE_BASE_PATH = '/iou';

// 活动列表接口
export const getList = p => get(`${RESOURCE_BASE_PATH}/query`, p);

// 商家详情接口
export const venderDetail = p => get(`${RESOURCE_BASE_PATH}/venderDetail`, p);

// POP签约接口
export const popSign = p => postJson(`${RESOURCE_BASE_PATH}/sign`, p);

// 活动退出接口
export const quit = p => get(`${RESOURCE_BASE_PATH}/quit/${p}`);

// 上传sku接口
export const checkSku = p => imagePost(`${RESOURCE_BASE_PATH}/checkSku`, p);

// 追加sku接口
export const appendSKU = p => postJson(`${RESOURCE_BASE_PATH}/appendSku`, p);

// 活动详情接口
export const getDetail = p => get(`${RESOURCE_BASE_PATH}/detail/${p}`);

// 创建活动
export const createActivity = p => postJson(`${RESOURCE_BASE_PATH}/createActivity`, p);

// 导出错误sku
export const exportFailSKU = p => postBlob(`/jd-hd-web/${RESOURCE_BASE_PATH}/exportFailSku`, p);

// 导出
export const exportSKU = p => get(`${RESOURCE_BASE_PATH}/exportSku/${p}`);